import { PersonaButtonType } from "@habity/types";

export const PERSONAS: PersonaButtonType[] = [
  {
    title: "Familj",
    key: "family",
    criteria: {
      places: ["O:R:398039", "O:N:15412058", "O:R:8844985"],
      living_space_min: 80,
      living_space_max: 150,
      rooms_min: 3,
      rooms_max: 6,
      price_min: 3000000,
      price_max: 8000000,
      categories: ["house", "apartment", "townhouse", "twinhouse"],
    },
  },
  {
    title: "Par",
    key: "couple",
    criteria: {
      places: ["O:N:25930131", "O:R:10663667", "O:N:25735371"],
      living_space_min: 50,
      living_space_max: 100,
      rooms_min: 2,
      rooms_max: 4,
      price_min: 2000000,
      price_max: 6000000,
      categories: ["house", "apartment", "townhouse", "twinhouse"],
      // nearby: ['supermarket'],
    },
  },
  {
    title: "Singel",
    key: "single",
    criteria: {
      places: ["O:R:5695411", "O:R:1517296", "O:R:5695402"],
      living_space_min: 20,
      living_space_max: 70,
      rooms_min: 1,
      rooms_max: 2,
      price_min: 1000000,
      price_max: 4000000,
      categories: ["apartment"],
    },
  },
  {
    title: "Student",
    key: "student",
    criteria: {
      places: ["O:N:6484319000", "O:W:528057227", "O:N:27408855"],
      living_space_min: 18,
      living_space_max: 30,
      rooms_min: 1,
      rooms_max: 2,
      price_min: 500000,
      price_max: 3000000,
      categories: ["apartment"],
    },
  },
  {
    title: "Ensamstående",
    key: "singleParent",
    criteria: {
      places: ["O:R:5695411", "O:R:3050065", "O:R:1517292"],
      living_space_min: 30,
      living_space_max: 70,
      rooms_min: 2,
      rooms_max: 3,
      price_min: 1000000,
      price_max: 4000000,
      categories: ["apartment"],
    },
  },
  {
    title: "Ungdom",
    key: "young",
    criteria: {
      places: ["O:R:5695402", "O:R:1517296", "O:R:398039"],
      living_space_min: 18,
      living_space_max: 50,
      rooms_min: 1,
      rooms_max: 2,
      price_min: 1000000,
      price_max: 3000000,
      categories: ["apartment"],
    },
  },
  {
    title: "Pensionär",
    key: "elderly",
    criteria: {
      places: ["O:R:397194", "O:N:328996112", "O:R:5525149"],
      living_space_min: 45,
      living_space_max: 125,
      rooms_min: 2,
      rooms_max: 4,
      price_min: 3000000,
      price_max: 8000000,
      categories: ["apartment"],
      // features: ['elevator'],
    },
  },
];
